module.exports = __webpack_public_path__ + "img/13fd9e89cf1dbbaf927f614cccd69509.png";